// Central place for brand asset rendering. Two PNGs live under
// /app/frontend/public/assets/:
//   • logo.png  → the "Loving Angels" wordmark (used in navbars, footers, login)
//   • icon.png  → the cherub/angel isotype (used as accent + favicon)
//
// Both files are BLACK on a transparent background. To adapt to dark
// surfaces (e.g. #1a1714 primary), pass `variant="light"` and this
// component applies `brightness-0 invert` which turns the black pixels
// pure white while preserving transparency. On cream surfaces
// (`bg-[var(--bg)]`, white cards), pass `variant="dark"` (default).

export function BrandLogo({
    variant = "dark",
    className = "",
    style,
    "data-testid": testId = "brand-logo",
    alt = "Loving Angels",
}) {
    const filterClass =
        variant === "light" ? "brightness-0 invert" : "";
    return (
        <img
            src="/assets/logo.png"
            alt={alt}
            data-testid={testId}
            className={`${filterClass} ${className}`.trim()}
            style={style}
            loading="eager"
        />
    );
}

export function BrandIcon({
    variant = "dark",
    className = "",
    style,
    "data-testid": testId = "brand-icon",
    alt = "Loving Angels",
}) {
    const filterClass =
        variant === "light" ? "brightness-0 invert" : "";
    return (
        <img
            src="/assets/icon.png"
            alt={alt}
            data-testid={testId}
            className={`${filterClass} ${className}`.trim()}
            style={style}
            loading="eager"
        />
    );
}
